import { useTracking } from 'react-tracking';

import { Alert, useMount } from '@simplywallst/ui-core';

import { PortfolioPageHeader } from '../../../../components/PortfolioPageHeader';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

type Props = {
  portfolio?: Portfolio;
};

const LinkingStatusCodeErrorState = ({ portfolio }: Props) => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'linkingStatusCodeErrorState',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <PortfolioPageHeader portfolio={portfolio} />
      <div
        data-cy-id="linking-status-code-error-state"
        className="gap-x mt-x3 grid w-full gap-x3 rounded-lg bg-surface-1 p-x3"
      >
        <Alert styleType="negative">
          Something went wrong! Please try to connect with your brokerage again.
        </Alert>
      </div>
    </Track>
  );
};

export default LinkingStatusCodeErrorState;
